import { ForwardedRef, ComponentPropsWithoutRef } from 'react';

import ContactField from './ContactField';

function PhoneField({
    ref = null,
    ...props
}: ComponentPropsWithoutRef<typeof ContactField> & {
    ref?: ForwardedRef<HTMLInputElement> | null;
}) {
    return <ContactField type="tel" {...props} ref={ref} />;
}

export default PhoneField;
